import React from 'react';

const DocEn = () => {
    return (
        <>
            <p>Authorization is granted according to the Oauth2 protocol with authorization_code token.</p>

            <p>Once the key created, you will have:</p>
            <ul>
                <li>an application key</li>
                <li>a secret key</li>
            </ul>
            <p>You can then "Authorize" the application, and get the authorization code.</p>

            <h2>Getting and using the token</h2>

            <p>With all those elements, you can get the connection token. Here is a walkthrough with curl:</p>
            <pre>
                curl -X POST -H "Content-Type: application/x-www-form-urlencoded" -d "grant_type=authorization_code&code=[CODE]&redirect_uri=https://dashboard.singlespot.com/oauth/applications&client_id=[APPLICATION_KEY]&client_secret=[SECRET]" https://dashboard.singlespot.com/oauth/token
            </pre>
            <p>You must replace:</p>
            <ul>
                <li><em>[CODE]</em>: authorization code</li>
                <li><em>[APPLICATION_KEY]</em>: application key</li>
                <li><em>[SECRET]</em>: secret key</li>
            </ul>
            <p>The response will look like the following:</p>
            <pre>
                {"{"}
                    "access_token":"[TOKEN]",
                    "token_type":"Bearer",
                    "expires_in":7200,
                    "refresh_token":"[REFRESH_TOKEN]",
                    "scope":"publisher_api",
                    "created_at":1564581408
                {"}"}
            </pre>

            <ul>
                <li><em>access_token</em>: token to use to get access</li>
                <li><em>expires_in</em>: number of seconds before token expiration</li>
                <li><em>refresh_token</em>: refresh token you can use before token expiration</li>
            </ul>

            <p>The token can then be used in the header:</p>

            <pre>
                curl https://api.singlespot.com/publisher_api/v1/devices -H "Authorization: Bearer [TOKEN]"
            </pre>

            <p>For more information, you can check <a href="https://auth0.com/docs/api-auth/tutorials/authorization-code-grant">the official documentation here</a>.</p>

            <h2>API parameters</h2>

            <p>By default, the API returns data for the current day.</p>

            <p>This date can be changed using some parameters:</p>

            <ul>
                <li>
                    <em>date</em>: to get data of the day <em>date</em> to be set using format 'YYYY-MM-DD'
                    <pre>
                        https://api.singlespot.com/publisher_api/v1/devices?date=YYYY-MM-DD
                    </pre>
                </li>
                <li>
                    <em>start_date</em> and <em>end_date</em>: to get data on the period from <em>start_date</em> to <em>end_date</em>. Date has to be set using format 'YYYY-MM-DD'
                    <pre>
                        https://api.singlespot.com/publisher_api/v1/devices?start_date=YYYY-MM-DD&end_date=YYYY-MM-DD
                    </pre>
                </li>
            </ul>
        </>
    );
};

export default DocEn;